import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{class:_vm.isSelected ? 'white--text' : undefined,attrs:{"disabled":_vm.disabled,"color":_vm.isSelected ? 'primary' : undefined},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,{attrs:{"left":"","dark":""}},[_vm._v("\n    "+_vm._s(_vm.isSelected
        ? 'mdi-checkbox-marked-outline'
        : 'mdi-checkbox-blank-outline')+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }